import React, { useEffect, useState, useContext } from 'react';
import { useParams } from "react-router-dom";
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf'
import Alert from 'react-s-alert';
import moment from 'moment';
import '../GenerateQuotation/GenerateQuoteStyle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import numberToEnglish from '../Common/CommonMethods';
import FailureAlert from '../Common/Failure';
import Barcode from 'react-barcode';
//import FormatEmail from '../Common/EmailService';
//import Base64 from 'base-64';
import Select from 'react-select';
import WaterMark from '../../Images/watermark_mfi.png';
import VehicleChart from '../Common/VehicleChart';
import whatsapp from '../../Images/whatsapp.png';
import Loader from '../Common/Loader';

const GenerateQuote = () => {
    var { QuoteID } = useParams();
    const { CurrentTheme } = useContext(ThemeContext);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [QuoationInfo, setQuoationInfo] = useState([]);
    const [QuotionDropDownInfo, setQuotionDropDownInfo] = useState([]);
    const [SelectedQuotionDropDownInfo, setSelectedQuotionDropDownInfo] = useState({ label: null, value: null });
    const [ProductsPDFInfo, setProductsPDFInfo] = useState([]);
    const [TotalAmountAndCustomerPDFInfo, setTotalAmountAndCustomerPDFInfo] = useState([]);
    const [SelectedQuotationPDFInfo, setSelectedQuotationPDFInfo] = useState(0);
    //const [EmailSettings, setEmailSettings] = useState({});
    const [companyLogo, setcompanyLogo] = useState("");
    const [IBAData, setIBAData] = useState({});
    const [IBALogo, setIBALogo] = useState("");
    const [SendWhatsapp, setSendWhatsapp] = useState({});
    const [QuotationNumber, setQuotationNumber] = useState("");
    const [PaymentCode, setPaymentCode] = useState(null);
    const [ParticularName, setParticularName] = useState("Other Charges");
    const [ParticularName1, setParticularName1] = useState("");
    const [ParticularName2, setParticularName2] = useState("");
    const [ParticularName1Amount, setParticularName1Amount] = useState(0);
    const [ParticularName2Amount, setParticularName2Amount] = useState(0);
    const [ParticularCount, setParticularCount] = useState(0);
    const [Loading, setLoading] = useState(false);

    const OrgData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;


    useEffect(() => {
        FetchInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchInitialData = () => {
        setLoading(true);
        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        var CompanyLogo = localStorage.getItem("CompanyLogo") ? localStorage.getItem("CompanyLogo") : null;
        if (userData && localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);

            if (CompanyLogo !== null) {
                setcompanyLogo(CompanyLogo);
            }
            else {
                setcompanyLogo("");
            }

            const orgID = JSON.parse(userData).OrganizationID;
            Axiosfetch(baseURL + "GetQuotationsByStatusAndOrg", "POST", { Status: 1, OrgID: orgID }, getQuotationsSuccess, Failure);
        }
        else {
            if (localStorage.getItem("CompanyInfo") !== null) {
                Alert.error("Error occured While Loading Quotations. Please login to the application again before attempting the steps.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
                setLoading(false);
            }
            else {
                Alert.error("Please update Company Info to proceed with Quotation.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
                setLoading(false);
            }
        }
    };

    const getQuotationsSuccess = (data) => {
        var quotations = [];
        var quotationsDropdown = [];
        data.forEach(value => {
            // if (moment(value.Validity) > moment(new Date())) {

            let QuotationNumber = "#" + value.QuoteID + "_" + moment(value.createdAt).local().format("DDMMYYYY");
            quotationsDropdown.push({ value: value.QuoteID, label: QuotationNumber });
            if (value.Goods.length > 0) {
                var cftValue = 0;
                value.Goods.forEach(survey => {
                    cftValue += (survey.CFTValue * survey.Quantity)
                });

                let vehcileData = VehicleChart.filter(v => v.MinCFT <= cftValue && v.MaxCFT >= cftValue);
                value.VehicleRequired = vehcileData.length > 0 ? vehcileData[0].TypeOfLoad : "NA";
            }
            else {
                if (value.IsInstant === 1 && value.InstantCustomerCFT && value.InstantCustomerCFT > 0) {
                    let vehcileData = VehicleChart.filter(v => v.MinCFT <= value.InstantCustomerCFT && v.MaxCFT >= value.InstantCustomerCFT);
                    value.VehicleRequired = vehcileData.length > 0 ? vehcileData[0].TypeOfLoad : "NA";
                }
            }

            quotations.push(value);
        });


        if (QuoteID !== undefined) {
            var quote = quotationsDropdown.filter(q => q.value === parseFloat(QuoteID));
            if (quote !== null && quote.length > 0) {
                setSelectedQuotionDropDownInfo(quote[0]);
                GetQuoteData(quote[0], quotations);
            }
        }

        setQuoationInfo(quotations);
        setQuotionDropDownInfo(quotationsDropdown);
        FetchOrgPaymentLogo();
        setLoading(false);
        //FetchEmailSettings();
    };

    const FetchOrgPaymentLogo = () => {
        let OrgPaymentCode = (OrgData.Organization && OrgData.Organization.length > 0) ? OrgData.Organization[0].PaymentLogo : null;
        if (OrgPaymentCode) {
            Axiosfetch(baseURL + "GetPaymentLogo", "POST", { fileName: OrgPaymentCode }, paymentCodeSuccess, Failure);
        }
    };

    const paymentCodeSuccess = (data) => {
        if (data.success) {
            setPaymentCode(data.fileData)
        }
        else {
            setPaymentCode(null);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
        setLoading(false);
    };

    const printPDF = () => {
        if (SelectedQuotationPDFInfo > 0) {
            setLoading(true);
            const domElement = document.getElementById('page');
            html2canvas(domElement, {
                scale: 1.6
            })
                .then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    // CreateSnapshot(imgData);
                    var imgWidth = 205;
                    var pageHeight = 295;
                    var imgHeight = canvas.height * imgWidth / canvas.width;
                    var heightLeft = imgHeight;
                    var doc = new jsPdf('p', 'mm');
                    var position = 2;

                    doc.addImage(imgData, 'PNG', 2, position, imgWidth, imgHeight, '', 'FAST');
                    heightLeft -= pageHeight;

                    while (heightLeft >= 0) {
                        position = heightLeft - imgHeight;
                        doc.addPage();

                        doc.setFontSize(8);
                        doc.setTextColor(149, 149, 149);

                        if ((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                            (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                                ProductsPDFInfo[0].InstantCustomerIBAApproved === 1 && IBAData && IBAData.IBAAddress)) {
                            doc.text(IBAData.AccountName, (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 20, { align: 'center' });
                            var splitTitle = doc.splitTextToSize("Address : " + IBAData.IBAAddress + (IBAData.EmailID ? ` , Email ID: ${IBAData.EmailID}${IBAData.AltEmailID ? ` , ${IBAData.AltEmailID}` : ""}` : ""), 180);
                            doc.text(splitTitle, (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 15, { align: 'center' });

                            doc.text((IBAData.Website ? "Visit : " + IBAData.Website : "") +
                                (IBAData.ContactNumber ? `, Ph : +91 ${IBAData.ContactNumber}${(IBAData.AltContactNumber !== 0 ? ` , +91 ${IBAData.AltContactNumber}` : "")}` : ""),
                                (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 8, { align: 'center' });
                            doc.text("** This is computer generated Document. No signature required **", (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 4, { align: 'center' });
                        }
                        else {

                            doc.text((OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].Name : ""), (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 18, { align: 'center' });
                            var splitTitle = doc.splitTextToSize("Address : " + companyInfo.BillingAddress + ", " + (OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].Country : ""), 180);
                            doc.text(splitTitle, (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 14, { align: 'center' });
                            doc.text("Visit : " + (OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].Website) +
                                ", Ph :" + (OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].Contact), (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 8, { align: 'center' });
                            doc.text("** This is computer generated Document. No signature required **", (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 4, { align: 'center' });
                        }


                        doc.addImage(imgData, 'PNG', 2, position, imgWidth, imgHeight, '', 'FAST');
                        heightLeft -= pageHeight;

                    }

                    doc.setFontSize(8);
                    doc.setTextColor(149, 149, 149);

                    if ((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                        (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                            ProductsPDFInfo[0].InstantCustomerIBAApproved === 1 && IBAData && IBAData.IBAAddress)) {
                        doc.text(IBAData.AccountName, (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 20, { align: 'center' });
                        var splitTitle = doc.splitTextToSize("Address : " + IBAData.IBAAddress + (IBAData.EmailID ? ` , Email ID: ${IBAData.EmailID}${IBAData.AltEmailID ? ` , ${IBAData.AltEmailID}` : ""}` : ""), 180);
                        doc.text(splitTitle, (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 16, { align: 'center' });

                        doc.text((IBAData.Website ? "Visit : " + IBAData.Website : "") +
                            (IBAData.ContactNumber ? `, Ph : +91 ${IBAData.ContactNumber}${(IBAData.AltContactNumber !== 0 ? ` , +91 ${IBAData.AltContactNumber}` : "")}` : ""),
                            (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 8, { align: 'center' });
                        doc.text("** This is computer generated Document. No signature required **", (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 4, { align: 'center' });
                    }
                    else {

                        doc.text((OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].Name : ""), (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 18, { align: 'center' });
                        var splitTitle = doc.splitTextToSize("Address : " + companyInfo.BillingAddress + ", " + (OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].Country : ""), 180);
                        doc.text(splitTitle, (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 14, { align: 'center' });
                        doc.text("Visit : " + (OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].Website) +
                            ", Ph :" + (OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].Contact), (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 8, { align: 'center' });
                        doc.text("** This is computer generated Document. No signature required **", (doc.internal.pageSize.width || doc.internal.pageSize.getWidth()) / 2, doc.internal.pageSize.getHeight() - 4, { align: 'center' });
                    }

                    doc.save('Quote_' + TotalAmountAndCustomerPDFInfo.QuoteID + "_" +
                        moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DDMMYYYY") + '.pdf');
                    setLoading(false);
                });
        }
        else {
            Alert.error("Please Select Quotation.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            setLoading(false);
        }
    };

    // const FetchEmailSettings = () => {
    //     Axiosfetch(baseURL + "GetEmailSettings", "GET", null, getEmailSettingsSuccess, Failure);
    // };

    // const getEmailSettingsSuccess = (data) => {
    //     if (data.length > 0) {
    //         setEmailSettings(data[0]);
    //     }
    //     else {
    //         setEmailSettings({});
    //     }
    // };

    // const SendEmail = () => {
    //     if (SelectedQuotationPDFInfo > 0) {
    //         const domElement = document.getElementById('page');
    //         html2canvas(domElement, {
    //             scale: 1.6
    //         })
    //             .then((canvas) => {
    //                 const imgData = canvas.toDataURL('image/png');
    //                 var imgWidth = 205;
    //                 var pageHeight = 295;
    //                 var imgHeight = canvas.height * imgWidth / canvas.width;
    //                 var heightLeft = imgHeight;
    //                 var doc = new jsPdf('p', 'mm');
    //                 var position = 2;

    //                 doc.addImage(imgData, 'PNG', 2, position, imgWidth, imgHeight, '', 'FAST');
    //                 heightLeft -= pageHeight;

    //                 while (heightLeft >= 0) {
    //                     position = heightLeft - imgHeight;
    //                     doc.addPage();

    //                     doc.addImage(imgData, 'PNG', 2, position + 1, imgWidth, imgHeight, '', 'FAST');
    //                     heightLeft -= pageHeight;

    //                 }

    //                 var out = doc.output();
    //                 var attachment = 'data:application/pdf;base64,' + Base64.encode(out);
    //                 var EmailData = EmailSettings;
    //                 let customEmail = TotalAmountAndCustomerPDFInfo.Customer ? TotalAmountAndCustomerPDFInfo.Customer.EmailID : null;
    //                 if (customEmail !== null || customEmail !== undefined) {

    //                     var QuoteNumber = "Quote/" + (TotalAmountAndCustomerPDFInfo.Customer ? TotalAmountAndCustomerPDFInfo.Customer.Name.split(' ')[0].trim() : "") +
    //                         "/#" + TotalAmountAndCustomerPDFInfo.ID + "/" + moment(TotalAmountAndCustomerPDFInfo.CreatedDate).local().format("DDMMYYYY")
    //                     if (QuoteNumber !== "") {
    //                         var TotalAmount = TotalAmountAndCustomerPDFInfo.TotalAmount.toFixed(2);

    //                         var FormattedEmail = FormatEmail(EmailData, customEmail, QuoteNumber,
    //                             companyInfo.Name, TotalAmount, "Quotation");
    //                         FormattedEmail.Attachment = attachment;
    //                         Axiosfetch(baseURL + "SendEmail", "POST", FormattedEmail, emailDataEditSuccess, Failure);
    //                     }
    //                     else {
    //                         Alert.success("Error getting Quotation Number. Please try again.", {
    //                             position: 'bottom-right',
    //                             effect: 'slide',
    //                             html: false
    //                         });
    //                     }

    //                 }
    //                 else {
    //                     Alert.success("Please add customer Email ID to send Email", {
    //                         position: 'bottom-right',
    //                         effect: 'slide',
    //                         html: false
    //                     });
    //                 }
    //             });
    //     }
    //     else {
    //         Alert.error("Please Select Invoice.", {
    //             position: 'bottom-right',
    //             effect: 'slide',
    //             html: false
    //         });
    //     }
    // };

    // const emailDataEditSuccess = (data) => {
    //     Alert.success(data, {
    //         position: 'bottom-right',
    //         effect: 'slide',
    //         html: false
    //     });
    // };

    const GetQuoteData = (Quotation, quoteData = null) => {
        if (Quotation !== null) {
            setParticularName("Other Charges");
            setParticularName1("");
            setParticularName2("");
            setParticularName1Amount(0);
            setParticularName2Amount(0);
            setParticularCount(0);

            let QuotationID = Quotation.value;
            setSelectedQuotationPDFInfo(QuotationID);
            var QuoationToGenerate = [];

            if (quoteData !== null) {
                QuoationToGenerate = quoteData.filter(q => q.QuoteID === QuotationID);
            }
            else {
                setSelectedQuotionDropDownInfo(Quotation);
                QuoationToGenerate = QuoationInfo.filter(q => q.QuoteID === QuotationID);
            }

            if (QuoationToGenerate.length > 0) {
                setTotalAmountAndCustomerPDFInfo(QuoationToGenerate[0]);

                if (QuoationToGenerate[0].Customer && QuoationToGenerate[0].Customer.length > 0) {
                    setSendWhatsapp({
                        Phone: QuoationToGenerate[0].Customer ? QuoationToGenerate[0].Customer[0].PhoneNumber : "",
                        Message: `${QuoationToGenerate[0].QuoteID}_${moment(QuoationToGenerate[0].createdAt).local().format("DDMMYYYY")}`
                    });
                }
                else if (QuoationToGenerate[0].InstantCustomerPhone !== undefined) {
                    setSendWhatsapp({
                        Phone: QuoationToGenerate[0].InstantCustomerPhone ? QuoationToGenerate[0].InstantCustomerPhone : "",
                        Message: `${QuoationToGenerate[0].QuoteID}_${moment(QuoationToGenerate[0].createdAt).local().format("DDMMYYYY")}`
                    });
                }

                var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
                Axiosfetch(baseURL + "GetQuotationsByQuoteAndOrgID", "POST", { QuoteID: QuotationID, OrgID: userData.OrganizationID }, ProductDataSuccess, Failure);
            }
        }
        else {
            setSelectedQuotationPDFInfo(0);
            setTotalAmountAndCustomerPDFInfo([]);
            setParticularName("Other Charges");
            setParticularName1("");
            setParticularName2("");
            setParticularName1Amount(0);
            setParticularName2Amount(0);
            setParticularCount(0);
            setSelectedQuotionDropDownInfo({ label: null, value: null });
        }
    }

    const setQuotationIDCriteria = (Quotation) => {
        GetQuoteData(Quotation);
    };

    const ProductDataSuccess = (data) => {
        if (data.length > 0) {
            setProductsPDFInfo(data);

            if (data[0].Partner && data[0].Partner.length > 0) {
                ComputeQuoteNumber(data);
            }

            if ((data[0].Customer && data[0].Customer.length > 0 && data[0].Customer[0].IBAApproval === 1)
                || (data[0].Customer.length === 0 && data[0].InstantCustomerIBAApproved === 1)) {
                Axiosfetch(baseURL + "GetActiveIBAData", "GET", null, IBADataSuccess, Failure);
            }
        }
        else {
            setProductsPDFInfo([]);
        }

    };

    const ComputeQuoteNumber = (QuoteData) => {
        let partnerDetails = QuoteData[0].Partner[0];
        let Name = partnerDetails.Name.split(' ').map(c => c[0]).join('');
        let QuoteNumber = `${Name}-${QuoteData[0].QuoteID.toString().padStart(4, '0')}_${moment(QuoteData[0].createdAt).local().format("DDMMYYYY")}`;

        setQuotationNumber(QuoteNumber);
    };

    const IBADataSuccess = (data) => {
        if (data.length > 0) {
            setIBAData(data[0]);
            Axiosfetch(baseURL + "GetIBAFile", "POST", { fileName: data[0].IBAFileName }, IBAFileDataSuccess, Failure);
        }
    };

    const IBAFileDataSuccess = (data) => {
        if (data.success) {
            if (data.fileData !== null) {
                setIBALogo(data.fileData);
            }
            else {
                Alert.error("Error fetching IBA Logo", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
        else {
            Alert.error("Error fetching IBA Logo", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    // const onWhatsappClick = () => {
    //     if (SendWhatsapp && SendWhatsapp.Phone && SendWhatsapp.Message) {
    //         var link = document.createElement('a');
    //         link.href = `https://api.whatsapp.com/send?phone=+91${SendWhatsapp.Phone}&text=Quotation No. ${SendWhatsapp.Message} is successfully Generated.`;
    //         link.target = "_blank";
    //         link.click();
    //     }
    //     else {
    //         Alert.error("Error Sending Whatsapp Message. Please try again.", {
    //             position: 'bottom-right',
    //             effect: 'slide',
    //             html: false
    //         });
    //     }
    // };

    const onParticularNameChange = (value) => {
        setParticularName(value);
    };

    const onParticularName1Change = (value) => {
        setParticularName1(value);
    };

    const onParticularName2Change = (value) => {
        setParticularName2(value);
    };

    const onParticularName1AmountChange = (value) => {
        setParticularName1Amount(parseFloat(parseFloat(value)));
    }

    const onParticularName2AmountChange = (value) => {
        setParticularName2Amount(parseFloat(parseFloat(value)));
    }

    const OnParticularCountChange = () => {
        if (ParticularCount < 2) {
            setParticularCount(ParticularCount + 1);
        }

    };

    const OnParticularCountRemoveChange = () => {
        setParticularName("Other Charges");
        setParticularName1("");
        setParticularName2("");
        setParticularName1Amount(0);
        setParticularName2Amount(0);
        setParticularCount(0);
    };

    const GetAccountType = (type) => {
        switch (type) {
            case 1: return "Current";
            case 2: return "Savings";
            case 3: return "CC";
            case 4: return "OD";
            default: return "Current";
        };
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme sidemenu-show">
                {Loading && (<Loader></Loader>)}
                <div className="row">
                    <div className="offset-md-1 col-md-4 col-12">
                        <div className="dropdownMobile">
                            <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Quotation"
                                options={QuotionDropDownInfo}
                                value={SelectedQuotionDropDownInfo.value !== null ? SelectedQuotionDropDownInfo : ''}
                                onChange={setQuotationIDCriteria}></Select>
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }} className="col-md-6 col-12 align-right trackbtn">
                        {SelectedQuotationPDFInfo !== 0 && (<div style={{ display: "flex", justifyContent: "space-around", width: "80px", marginRight: "20px", borderRadius: "20px", border: "1px solid #ccc" }}>
                            <span className="hover-style" style={{ padding: "5px", color: "green" }} onClick={OnParticularCountChange}>
                                <FontAwesomeIcon title="Add New Particular" icon={faPlus}></FontAwesomeIcon>
                            </span>
                            <span className="hover-style" style={{ padding: "5px", color: "red" }} onClick={OnParticularCountRemoveChange}>
                                <FontAwesomeIcon title="Remove Particular(s)" icon={faTimes}></FontAwesomeIcon>
                            </span>
                        </div>)}
                        {(SelectedQuotationPDFInfo !== 0 && SendWhatsapp.Phone && SendWhatsapp.Phone !== "") && (
                            <a rel="noopener noreferrer" target="_blank" href={`https://wa.me/${(SendWhatsapp.Phone.toString().length > 0 &&
                                ((SendWhatsapp.Phone.toString()[0] === "9" && SendWhatsapp.Phone.toString()[1] === "1") ||
                                    SendWhatsapp.Phone.toString()[0] === "0") ? (SendWhatsapp.Phone.toString()[0] === "0" ? "" : "+") : "+91")}${SendWhatsapp.Phone}?text=Quotation No. *${SendWhatsapp.Message}* is successfully Generated.`}
                                className="cursor hover-style" style={{ paddingTop: "4px" }}>
                                <span title="Send Message" style={{ cursor: "pointer", marginRight: "20px", backgroundImage: ("url('" + whatsapp + "')"), display: "inline-block", backgroundPosition: "center", height: "30px", width: "30px", backgroundRepeat: "no-repeat", backgroundSize: "contain" }}></span>
                            </a>
                        )}
                        {/* {parseInt(process.env.REACT_APP_EMAIL_REQUIRED) === 1 && (<button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SendEmail}>Email</button>)} */}
                        {SelectedQuotationPDFInfo !== 0 && (<div>
                            <div style={{ fontSize: "1.6rem" }} className={`hover-style ${CurrentTheme}Color`} onClick={printPDF}>
                                <FontAwesomeIcon title="Generate PDF" icon={faFilePdf}></FontAwesomeIcon>
                            </div>
                        </div>)}
                    </div>

                </div>
                <hr></hr>

                {(SelectedQuotationPDFInfo > 0 && TotalAmountAndCustomerPDFInfo) && (<div className=""><div className="row" id="page">
                    <div className="col-md-12" style={{ fontSize: "17px" }}>

                        <div className="WaterMarkStyle" style={{ backgroundImage: (OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].LogoApproval && OrgData.Organization[0].LogoApproval === 1) ? "url('" + WaterMark + "')" : "none" }}>
                            <div className="row GenerateQuoteTitleStyle">
                                <div className="col-md-6 col-12 responsive-align">
                                    <div style={{ fontSize: "40px", color: "#005582", paddingLeft: "6px", fontWeight: "600" }}>QUOTATION</div>
                                    <div className='text-uppercase' style={{ color: "gray", fontSize: "13px", paddingLeft: "6px" }}>
                                        {OrgData && OrgData._id && OrgData._id !== "" && `${moment(TotalAmountAndCustomerPDFInfo.createdAt).format("DD/MM/YYYY hh:mm:ss") !== moment(TotalAmountAndCustomerPDFInfo.updatedAt).format("DD/MM/YYYY hh:mm:ss") ? "R_" : ""}${OrgData._id}_${moment().format("DDMMYYYY_hhmm")}`}
                                    </div>
                                    <div>
                                        <Barcode width={1} height={35} displayValue={true}
                                            value={TotalAmountAndCustomerPDFInfo.QuoteID + "_" + moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DDMMYYYY")}></Barcode>
                                    </div>
                                </div>
                                <div style={{
                                    display: "flex"
                                }} className={`${((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                                    (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                                        ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ? "col-md-6" : "offset-md-2 col-md-4"} col-12 align-right`}>

                                    {/* {((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                                        (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                                            ProductsPDFInfo[0].InstantCustomerIBAApproved === 1 && IBAData && IBAData.IBAAddress)) ? 
                                            <div style={{ width: "100%", fontSize: "13px", padding: "20px 10px 10px 10px", borderRight: "1px solid #ccc" }}>
                                        <div>{IBAData.IBAAddress ? IBAData.IBAAddress : ""}</div>
                                        {IBAData.ContactNumber && (<div style={{ paddingTop: "5px" }}><span style={{ fontWeight: "600" }}>Ph:</span>{IBAData.ContactNumber ? ` +91 ${IBAData.ContactNumber}${IBAData.AltContactNumber !== 0 ? ` , +91 ${IBAData.AltContactNumber}` : ""}` : ""}</div>)}
                                        {IBAData.EmailID && (<div><span style={{ fontWeight: "600" }}>Email:</span>{IBAData.EmailID ? ` ${IBAData.EmailID}${IBAData.AltEmailID ? ` , ${IBAData.AltEmailID}` : ""}` : ""}</div>)}
                                        {IBAData.Website && (<div><span style={{ fontWeight: "600" }}>Visit Us:</span>{IBAData.Website ? ` ${IBAData.Website}` : ""}</div>)}
                                    </div> : ""} */}

                                    {((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                                        (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                                            ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ?
                                        <div style={{ width: "100%", fontSize: "13px", padding: "20px 10px 10px 10px", borderRight: "1px solid #ccc" }}>
                                            <div>{companyInfo.BillingAddress}</div>
                                            <div>{OrgData.Organization && OrgData.Organization.length > 0 && "Visit : " + OrgData.Organization[0].Website}</div>
                                            <div>{OrgData.Organization && OrgData.Organization.length > 0 && "Ph : " + OrgData.Organization[0].Contact}</div>
                                        </div> : ""}

                                    {(ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length > 0) && (<div className="responsive-align" style={{ width: (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ? "40%" : "100%" }}><img alt="Logo" className="WaterMarkStyle" style={{ width: "9rem", height: "8rem" }} src={ProductsPDFInfo[0].Customer[0].IBAApproval === 0 ? companyLogo : (IBALogo === "" ? companyLogo : IBALogo)}></img></div>)}
                                    {(ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0) && (<div className="responsive-align" style={{ width: (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1) ? "40%" : "100%" }}><img alt="Logo" className="WaterMarkStyle" style={{ width: "9rem", height: "8rem" }} src={ProductsPDFInfo[0].InstantCustomerIBAApproved === 0 ? companyLogo : (IBALogo === "" ? companyLogo : IBALogo)}></img></div>)}
                                </div>
                                <div className="col-md-12" style={{ marginTop: "10px" }}>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-12" style={{ overflow: "auto", border: "1px solid #ccc", borderRadius: "6px" }}>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><span style={{ fontWeight: "600" }}>QTN. No:</span><span className='text-uppercase'> {QuotationNumber}</span></td>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><span style={{ fontWeight: "600" }}>Date:</span> {moment(TotalAmountAndCustomerPDFInfo.createdAt).local().format("DD.MM.YYYY")}</td>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><span style={{ fontWeight: "600" }}>Enquiry Date:</span> {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length > 0 ? moment(TotalAmountAndCustomerPDFInfo.Customer[0].createdAt).local().format("DD.MM.YYYY") : ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><span style={{ fontWeight: "600" }}>Enquiry From:</span>
                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length > 0 ?
                                                                <span style={{ paddingLeft: "5px" }}>{TotalAmountAndCustomerPDFInfo.Customer[0].Name}</span> : ""}
                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length === 0 ?
                                                                <span style={{ paddingLeft: "5px" }}>{TotalAmountAndCustomerPDFInfo.InstantCustomerName}</span> : ""}
                                                        </td>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><span style={{ fontWeight: "600" }}>Phone</span>:
                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length > 0 ?
                                                                <span style={{ paddingLeft: "5px" }}>{TotalAmountAndCustomerPDFInfo.Customer[0].PhoneNumber}</span> : ""}
                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length === 0 ?
                                                                <span style={{ paddingLeft: "5px" }}>{TotalAmountAndCustomerPDFInfo.InstantCustomerPhone}</span> : ""}
                                                        </td>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}><span style={{ fontWeight: "600" }}>Email</span>:
                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length > 0 ?
                                                                <span style={{ paddingLeft: "5px" }}>{TotalAmountAndCustomerPDFInfo.Customer[0].EmailID}</span> : ""}
                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length === 0 ?
                                                                <span style={{ paddingLeft: "5px" }}>{TotalAmountAndCustomerPDFInfo.InstantCustomerEmail}</span> : ""}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="2" style={{ borderBottom: "1px solid #ccc" }}>
                                                            <div style={{ width: "80%" }}><span style={{ fontWeight: "600" }}>From</span>:
                                                                {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length > 0 ?
                                                                    " " + TotalAmountAndCustomerPDFInfo.Customer[0].OriginAddress + " , " + TotalAmountAndCustomerPDFInfo.Customer[0].OriginCity + " " +
                                                                    TotalAmountAndCustomerPDFInfo.Customer[0].OriginPincode + " , " + TotalAmountAndCustomerPDFInfo.Customer[0].OriginState + " , " +
                                                                    TotalAmountAndCustomerPDFInfo.Customer[0].OriginCountry : ""}

                                                                {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length === 0 ?
                                                                    " " + TotalAmountAndCustomerPDFInfo.InstantCustomerOriginCity + " , " +
                                                                    TotalAmountAndCustomerPDFInfo.InstantCustomerOriginPincode : ""}
                                                            </div>
                                                        </td>
                                                        <td style={{ borderBottom: "1px solid #ccc" }}>
                                                            <div><span style={{ fontWeight: "600" }}>To</span>:
                                                                {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length > 0 ?
                                                                    " " + TotalAmountAndCustomerPDFInfo.Customer[0].DestinationAddress + " , " + TotalAmountAndCustomerPDFInfo.Customer[0].DestinationCity + " " +
                                                                    TotalAmountAndCustomerPDFInfo.Customer[0].DestinationPincode + " , " + TotalAmountAndCustomerPDFInfo.Customer[0].DestinationState + " , " +
                                                                    TotalAmountAndCustomerPDFInfo.Customer[0].DestinationCountry : ""}

                                                                {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length === 0 ?
                                                                    " " + TotalAmountAndCustomerPDFInfo.InstantCustomerDestCity + " , " +
                                                                    TotalAmountAndCustomerPDFInfo.InstantCustomerDestPincode : ""}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><span style={{ fontWeight: "600" }}>Loading Floor</span>:
                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length > 0 ?
                                                                ` ${TotalAmountAndCustomerPDFInfo.Customer[0].OriginFloor}` : ""}

                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length === 0 ?
                                                                ` ${TotalAmountAndCustomerPDFInfo.InstantCustomerOriginFloor}` : ""}
                                                        </td>
                                                        <td><span style={{ fontWeight: "600" }}>Unloading Floor</span>:
                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length > 0 ?
                                                                ` ${TotalAmountAndCustomerPDFInfo.Customer[0].DesinationFloor}` : ""}

                                                            {TotalAmountAndCustomerPDFInfo.Customer && TotalAmountAndCustomerPDFInfo.Customer.length === 0 ?
                                                                ` ${TotalAmountAndCustomerPDFInfo.InstantCustomerDestFloor}` : ""}
                                                        </td>
                                                        <td><span style={{ fontWeight: "600" }}>Vehicle Load</span>: {(TotalAmountAndCustomerPDFInfo.VehicleRequired ? TotalAmountAndCustomerPDFInfo.VehicleRequired : "NA")}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row" style={{ marginTop: "10px" }}>
                                        <div className="col-md-12 align-left">

                                            <div>
                                                We are pleased to present our proposal  for your consideration with assurance that with
                                                {((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                                                    (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                                                        ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ? <span style={{ fontWeight: "600" }}>{IBAData ? ` "${IBAData.AccountName}" ` : ""}</span> :
                                                    <b>{(OrgData.Organization && OrgData.Organization.length > 0 ? `"${OrgData.Organization[0].Name}" ` : "us")}</b>}
                                                your consignment would  be packed and moved with utmost professionalism  and care with door to door.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row title" style={{ marginTop: "10px" }}>
                                <div className="col-md-12">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-center InvoicePDFtitleStyle" >No.</th>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-left InvoicePDFtitleStyle">Particular</th>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-center InvoicePDFtitleStyle">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="align-center">
                                                <td>1</td>
                                                <td className="align-left">Wrapping & Packing Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].PackingCharges.toFixed(2)}</td>
                                            </tr>
                                            <tr className="align-center">
                                                <td>2</td>
                                                <td className="align-left">Loading & Stuffing Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].LoadingCharges.toFixed(2)}</td>
                                            </tr>
                                            <tr className="align-center">
                                                <td>3</td>
                                                <td className="align-left">Pickup & Delivery Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].PickupCharges.toFixed(2)}</td>
                                            </tr>
                                            <tr className="align-center">
                                                <td>4</td>
                                                <td className="align-left">Moving & Transport Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].TransportCharges.toFixed(2)}</td>
                                            </tr>
                                            <tr className="align-center">
                                                <td>5</td>
                                                <td className="align-left">Unloading Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].UnloadingCharges.toFixed(2)}</td>
                                            </tr>
                                            <tr className="align-center">
                                                <td>6</td>
                                                <td className="align-left">Unpacking & Settling Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].UnpackingCharges.toFixed(2)}</td>
                                            </tr>
                                            <tr className="align-center">
                                                <td>7</td>
                                                <td className="align-left">Automobile Transport Charges</td>
                                                <td className="align-center">{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].CarTransportCharges.toFixed(2)}</td>
                                            </tr>
                                            <tr className="align-center">
                                                <td>8</td>
                                                <td className="align-left">
                                                    <input className="inputfocus" style={{ width: "100%", border: "none", backgroundColor: "transparent" }} onChange={(e) => onParticularNameChange(e.target.value)} type="text" value={ParticularName}></input>
                                                </td>
                                                <td className="align-center">{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].OtherCharges.toFixed(2)}</td>
                                            </tr>

                                            {(ParticularCount > 0 && (ParticularCount >= 1 || ParticularCount <= 2)) && (<tr className="align-center">
                                                <td>9</td>
                                                <td className="align-left">
                                                    <input className="inputfocus" style={{ width: "100%", border: "none", backgroundColor: "transparent" }} onChange={(e) => onParticularName1Change(e.target.value)} type="text" value={ParticularName1}></input>
                                                </td>
                                                <td className="align-center">
                                                    <input className="inputfocus align-center" style={{ width: "100%", border: "none", backgroundColor: "transparent" }} onChange={(e) => onParticularName1AmountChange(e.target.value)} type="text" value={!isNaN(ParticularName1Amount) ? ParticularName1Amount : ""}></input>
                                                </td>
                                            </tr>)}

                                            {ParticularCount === 2 && (<tr className="align-center">
                                                <td>10</td>
                                                <td className="align-left">
                                                    <input className="inputfocus" style={{ width: "100%", border: "none", backgroundColor: "transparent" }} onChange={(e) => onParticularName2Change(e.target.value)} type="text" value={ParticularName2}></input>
                                                </td>
                                                <td className="align-center">
                                                    <input className="inputfocus align-center" style={{ width: "100%", border: "none", backgroundColor: "transparent" }} onChange={(e) => onParticularName2AmountChange(e.target.value)} type="text" value={!isNaN(ParticularName2Amount) ? ParticularName2Amount : ""}></input>
                                                </td>
                                            </tr>)}
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                            {TotalAmountAndCustomerPDFInfo.IsInstant === 1 && TotalAmountAndCustomerPDFInfo.InstantCustomerRemarks && TotalAmountAndCustomerPDFInfo.InstantCustomerRemarks !== "" && (<div className="row title">
                                <span style={{ fontWeight: "600" }}>Remarks</span>: {(TotalAmountAndCustomerPDFInfo.InstantCustomerRemarks ? TotalAmountAndCustomerPDFInfo.InstantCustomerRemarks : "")}
                            </div>)}
                            <div className="row title">
                                <div className={"col-md-7 col-sm-7 col-12"}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5><span style={{ fontWeight: "600" }}>BANK ACCOUNT DETAILS</span></h5>
                                        </div>
                                        <div className="col-md-12" style={{ paddingTop: "5px" }}>
                                            <div className="row">
                                                <div className="col-md-5 col-sm-5 col-6">
                                                    Bank Name & Branch
                                                </div>
                                                <div className="col-md-7 col-sm-7 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer) &&
                                                        ((ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1)
                                                            || (ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.BankName}, {IBAData.Branch}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{companyInfo.BankName}, {companyInfo.Branch}</h6>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-5 col-sm-5 col-6">
                                                    Account Number
                                                </div>
                                                <div className="col-md-7 col-sm-7 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer) &&
                                                        ((ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1)
                                                            || (ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.AccountNumber}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{companyInfo.AccountNumber}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-5 col-sm-5 col-6">
                                                    IFSC Code
                                                </div>
                                                <div className="col-md-7 col-sm-7 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer) &&
                                                        ((ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1)
                                                            || (ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.IFSCCode}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{companyInfo.IFSCCode}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-5 col-sm-5 col-6">
                                                    Account Name
                                                </div>
                                                <div className="col-md-7 col-sm-7 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer) &&
                                                        ((ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1)
                                                            || (ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.AccountName}</h6>
                                                        : companyInfo.AccountName && (<h6 style={{ fontWeight: "600" }}>{companyInfo.AccountName}</h6>)}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ paddingBottom: "10px" }}>
                                            <div className="row">
                                                <div className="col-md-5 col-sm-5 col-6">
                                                    Account Type
                                                </div>
                                                <div className="col-md-7 col-sm-7 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer) &&
                                                        ((ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1)
                                                            || (ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ?
                                                        <h6 style={{ fontWeight: "600" }}>{GetAccountType(IBAData.AccountType)}</h6>
                                                        : companyInfo.AccountType && (<h6 style={{ fontWeight: "600" }}>{GetAccountType(companyInfo.AccountType)}</h6>)}

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ paddingTop: "10px" }}>
                                            <div className="row">
                                                <div className="col-md-5 col-sm-5 col-6">
                                                    PAN Number
                                                </div>
                                                <div className="col-md-7 col-sm-7 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer) &&
                                                        ((ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1)
                                                            || (ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.PANNumber}</h6> :
                                                        <h6 style={{ fontWeight: "600" }}>{OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].PANNumber : ""}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-5 col-sm-5 col-6">
                                                    GST Number
                                                </div>
                                                <div className="col-md-7 col-sm-7 col-6">
                                                    {(ProductsPDFInfo && ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer) &&
                                                        ((ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1)
                                                            || (ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ?
                                                        <h6 style={{ fontWeight: "600" }}>{IBAData.GSTNumber}</h6>
                                                        : <h6 style={{ fontWeight: "600" }}>{OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].GSTNumber : ""}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        {((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                                            (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                                                ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) && (<div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-md-5 col-sm-5 col-6">
                                                            Issued By
                                                        </div>
                                                        <div className="col-md-7 col-sm-7 col-6">
                                                            <h6 style={{ fontWeight: "600" }}>{OrgData.Organization && OrgData.Organization.length > 0 ? "MFI " + OrgData.Organization[0].City + " [" + OrgData.Organization[0].Name + "]" : ""}</h6>
                                                        </div>
                                                    </div>
                                                </div>)}
                                        {((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                                            (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                                                ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) && (<div className="col-md-12">
                                                    <div className="row" style={{ color: "red", fontSize: "18px" }}>
                                                        <div className="col-md-5 col-sm-5 col-6">
                                                            <span style={{ fontWeight: "600" }}>IBA No.</span>
                                                        </div>
                                                        <div className="col-md-7 col-sm-7 col-6">
                                                            <span style={{ fontWeight: "600" }}>{IBAData.IBANumber ? IBAData.IBANumber : ""}</span>
                                                        </div>
                                                    </div>
                                                </div>)}
                                        {ProductsPDFInfo && ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Partner && ProductsPDFInfo[0].Partner.length > 0 &&
                                            ProductsPDFInfo[0].Partner[0].UPIApproval !== undefined && ProductsPDFInfo[0].Partner[0].UPIApproval === 1 && PaymentCode && PaymentCode !== "" && (<div style={{ marginTop: "15px" }} className="col-md-12 col-12">
                                                <div className="row">
                                                    <div className="col-md-5 col-sm-5 col-12">
                                                        <h5><span style={{ fontWeight: "600" }}>PAYMENT QR CODE</span></h5>
                                                        <div style={{ color: "#878787" }}>PhonePe / Google Pay / PayTM</div>
                                                        <div>UPI ID:</div>
                                                        <div>{ProductsPDFInfo[0].Partner[0].UPIID}</div>
                                                    </div>
                                                    <div className="col-md-7 col-sm-7 col-12" style={{ padding: "0px" }}>
                                                        <img width="120" height="120" alt="Payment Code" src={PaymentCode}></img>
                                                    </div>
                                                </div>
                                            </div>)}
                                    </div>
                                </div>
                                <div className="col-md-5 col-sm-5 col-12 align-right">
                                    <table className="table">
                                        <tbody>
                                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                                <td>AMOUNT</td>
                                                <td>
                                                    <span style={{ fontWeight: "600" }}> {ProductsPDFInfo.length > 0 && (parseFloat(isNaN(ParticularName1Amount) ? 0 : ParticularName1Amount) + parseFloat(isNaN(ParticularName2Amount) ? 0 : ParticularName2Amount) + parseFloat(ProductsPDFInfo[0].TotalAmount))}</span>
                                                </td>
                                            </tr>
                                            {((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IsGSTAvailable === 1) ||
                                                (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerGSTAvailable === 1)) && (<tr style={{ borderBottom: "1px solid #ccc" }}>
                                                    <td >GST (5%)</td>
                                                    <td>
                                                        <span style={{ fontWeight: "600" }}> {ProductsPDFInfo.length > 0 && (0.05 * ProductsPDFInfo[0].TotalAmount).toFixed(2)}</span>
                                                    </td>
                                                </tr>)}
                                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                                <td><span style={{ fontWeight: "600" }}>GRAND TOTAL</span></td>
                                                <td>
                                                    <span style={{ fontWeight: "600" }}>{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length > 0 ? (ProductsPDFInfo[0].Customer[0].IsGSTAvailable === 1 ?
                                                        (((0.05 * ProductsPDFInfo[0].TotalAmount) + ProductsPDFInfo[0].TotalAmount + parseFloat(isNaN(ParticularName1Amount) ? 0 : ParticularName1Amount) + parseFloat(isNaN(ParticularName2Amount) ? 0 : ParticularName2Amount)).toFixed(2)) :
                                                        parseFloat(isNaN(ParticularName1Amount) ? 0 : ParticularName1Amount) + parseFloat(isNaN(ParticularName2Amount) ? 0 : ParticularName2Amount) + ProductsPDFInfo[0].TotalAmount) : ""}</span>
                                                    <span style={{ fontWeight: "600" }}>{ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length === 0 ? (ProductsPDFInfo[0].InstantCustomerGSTAvailable === 1 ?
                                                        (((0.05 * ProductsPDFInfo[0].TotalAmount) + ProductsPDFInfo[0].TotalAmount + parseFloat(isNaN(ParticularName1Amount) ? 0 : ParticularName1Amount) + parseFloat(isNaN(ParticularName2Amount) ? 0 : ParticularName2Amount)).toFixed(2)) :
                                                        parseFloat(isNaN(ParticularName1Amount) ? 0 : ParticularName1Amount) + parseFloat(isNaN(ParticularName2Amount) ? 0 : ParticularName2Amount) + ProductsPDFInfo[0].TotalAmount) : ""}</span>
                                                </td>
                                            </tr>
                                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                                <td colSpan="2">
                                                    <div>Quotation Amount (in words)</div>
                                                    <span style={{ fontWeight: "600" }}><div>
                                                        {(ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length > 0) && (<span style={{ textTransform: "uppercase" }}>
                                                            {numberToEnglish(((ProductsPDFInfo[0].Customer[0].IsGSTAvailable === 1 ? (0.05 * ProductsPDFInfo[0].TotalAmount) : 0) + ProductsPDFInfo[0].TotalAmount + parseFloat(isNaN(ParticularName1Amount) ? 0 : ParticularName1Amount) + parseFloat(isNaN(ParticularName2Amount) ? 0 : ParticularName2Amount)).toFixed(2), "IN")}
                                                        </span>)}
                                                        {(ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length === 0) && (<span style={{ textTransform: "uppercase" }}>
                                                            {numberToEnglish(((ProductsPDFInfo[0].InstantCustomerGSTAvailable === 1 ? (0.05 * ProductsPDFInfo[0].TotalAmount) : 0) + ProductsPDFInfo[0].TotalAmount + parseFloat(isNaN(ParticularName1Amount) ? 0 : ParticularName1Amount) + parseFloat(isNaN(ParticularName2Amount) ? 0 : ParticularName2Amount)).toFixed(2), "IN")}
                                                        </span>)}
                                                    </div></span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2"><span style={{ fontWeight: "600" }}>Remarks</span>
                                                    <div>
                                                        {ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Remarks}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>


                                {companyInfo.QuotationTerms !== null && companyInfo.QuotationTerms !== undefined && (<div className="col-md-12 col-12">
                                    <hr></hr>
                                    <div>
                                        <h5> Terms and Conditions</h5>
                                    </div>
                                    <ol>
                                        {ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 1 && IBAData.IBATerms && IBAData.IBATerms.split('|').map((terms, index) => (
                                            <li key={index} dangerouslySetInnerHTML={{ __html: terms }}>
                                            </li>
                                        ))}
                                        {ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length === 0 && ProductsPDFInfo[0].InstantCustomerIBAApproved === 0 && companyInfo.QuotationTerms.split('|').map((terms, index) => (
                                            <li key={index} dangerouslySetInnerHTML={{ __html: terms }}>
                                            </li>
                                        ))}
                                        {ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 0 && companyInfo.QuotationTerms.split('|').map((terms, index) => (
                                            <li key={index} dangerouslySetInnerHTML={{ __html: terms }}>
                                            </li>
                                        ))}
                                        {ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1 && IBAData.IBATerms && IBAData.IBATerms.split('|').map((terms, index) => (
                                            <li key={index} dangerouslySetInnerHTML={{ __html: terms }}>
                                            </li>
                                        ))}
                                    </ol>

                                </div>)}
                            </div>
                            <div className="row" style={{ paddingBottom: "30px" }}>
                                <div className="col-md-12 align-left" style={{ paddingLeft: "2rem" }}>
                                    <div>Thanking you and looking forward to receive your valuable order.</div>
                                    <div>With Regards, </div>
                                    <div className='row'>
                                        <div className="col-md-12 col-12">
                                            {((ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer && ProductsPDFInfo[0].Customer.length > 0 && ProductsPDFInfo[0].Customer[0].IBAApproval === 1) ||
                                                (ProductsPDFInfo.length > 0 && ProductsPDFInfo[0].Customer !== undefined && ProductsPDFInfo[0].Customer.length === 0 &&
                                                    ProductsPDFInfo[0].InstantCustomerIBAApproved === 1)) ? <div style={{ fontWeight: "600" }}>For {IBAData.AccountName}
                                                <div>
                                                    <div style={{ paddingTop: "50px", fontWeight: "600" }}>Authorized Signatory</div>
                                                </div></div> : <span style={{ fontWeight: "600" }}><div>{OrgData.Organization && OrgData.Organization.length > 0 ? OrgData.Organization[0].Name : ""}</div></span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row" style={{ paddingBottom: "30px" }}>
                                <div className="col-md-12 col-12 align-left footer-style">
                                    <div>Off Address : {companyInfo.BillingAddress}</div>
                                    <div>visit : {OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].Website}</div>
                                    <div>Ph : {OrgData.Organization && OrgData.Organization.length > 0 && OrgData.Organization[0].Contact}</div>

                                </div>
                            </div> */}
                        </div>
                    </div>
                </div></div>)}
            </div>
        </div >
    );
};

export default GenerateQuote;